import { useMemo } from 'react'
import { Flags } from '~/components/flags'

export const InputCreditCardFlags = ({
  inputValue,
}: { inputValue: string }) => {
  const variant = useMemo(() => {
    if (inputValue.startsWith('34') || inputValue.startsWith('37'))
      return 'amex'
    if (
      inputValue.startsWith('4011') ||
      inputValue.startsWith('4312') ||
      inputValue.startsWith('4389')
    )
      return 'elo'
    if (inputValue.startsWith('6062')) return 'hypercard'
    if (inputValue.startsWith('5') || inputValue.startsWith('2'))
      return 'mastercard'
    if (inputValue.startsWith('4')) return 'visa'
    return
  }, [inputValue])

  return <Flags.CreditCards variant={variant} size="sm" />
}
